import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
`;

export const RowInputs = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	margin-bottom: 16px;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		grid-template-columns: 1fr;
	}
`;

export const ContainerSidebar = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	background: ${({ theme }) => theme.pantone656C};
	padding: 1rem;
	border-radius: 8px;
	width: 100%;
`;

export const ContainerFile = styled.div`
	margin: 20px 0;
`;

export const AreaStatus = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const LinkText = styled.span<{ $isDisabled: boolean }>`
	color: ${({ theme }) => theme.pantone2727C};
	opacity: ${(prop) => (prop.$isDisabled ? 0.7 : 1)};

	&:hover {
		cursor: ${(prop) => (prop.$isDisabled ? "default" : "pointer")};
		text-decoration: ${(prop) => (prop.$isDisabled ? "none" : "underline")};
	}
`;
